import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReduxLogin from "../store/actionreducers/auth/login";
import cookie from 'react-cookies'

class ApiAuth extends Component {
    componentDidMount() {

        const {loginWithApiToken} = this.props;

        // 參考資料 : https://www.npmjs.com/package/react-cookies
        const apiToken = cookie.load('apiToken');

        if (!apiToken) {
            return;
        }

        loginWithApiToken({apiToken});
    }

    render() {

        const {children} = this.props;

        return (
            <React.Fragment>
                {children}
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({loginWithApiToken: ReduxLogin.ActionCreator.loginWithApiToken}, dispatch);
}


function mapStateToProps({auth}) {
    return {user: auth.user}
}


export default connect(mapStateToProps, mapDispatchToProps)(ApiAuth);



// WEBPACK FOOTER //
// ./src/main/ApiAuth.js